<template>
  <div class="recording-detail-container">
    <div class="recording-detail-header">
      <div class="header-left">
        <div class="recording-detail-title">
          <div class="recording-detail-title-text">Select a Playsession</div>
        </div>   
      </div>
    </div>
  </div>
</template>

<script>
export default {
        name: "RecordingsListDeveloper",
        data() {
            return {
              
              userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1, // 0: Tester | 1: Dev | 2: Admin
              /*
              gameName: window.localStorage.getItem("gameName"),

              recordingID: window.localStorage.getItem("recordingID"),
              recordingTitle: window.localStorage.getItem("recordingTitle"),  // all "recording----" items need to be implemented
              recordingDate: window.localStorage.getItem("recordingDate"),    // into the firebase/database - look at this later
              recordingLength: window.localStorage.getItem("recordingLength"),// when we do the actual web-based recording components
              recordingSize: window.localStorage.getItem("recordingOtherInfo")// TL;DR: THIS IS PLACEHOLDER!
              */  
            }
        },
        mounted() {
            // redirect to login if user is not logged in!
            if (window.localStorage.getItem("userType")) {
                this.userType = parseInt(window.localStorage.getItem("userType"));
            }
            else {
                this.$router.push({
                    name: 'login',
                })
            }
        },
         
            
    }
</script>

<style scoped>
.recording-detail-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  width: 100%;
}

.recording-detail-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 10%;
  min-height:10%;
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
}

.header-left {
  margin-left: 33%;
  display: flex;
  flex-direction: row;
}
.recording-detail-title {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  /* width: 50%; */
  align-items: center;
  justify-content: center;
}
.recording-detail-title-text {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 46px;
  color: #fc7727;
  vertical-align: bottom;
}
</style>
<script setup lang="ts">
import GamesObject from '../../../Firestore/GamesObject';

</script>



// WEBPACK FOOTER //
// src/components/game-detail/Recordings/RecordingView.vue